import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_2 = { class: "p-field p-col p-col-12 p-md-12 p-lg-12" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "flex align-items-center gap-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "font-bold white-space-nowrap" }, "Xuất báo cáo theo giá trị ")
], -1)
const _hoisted_4 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "p-field p-col p-col-12 p-md-12 p-lg-12" }, null, -1)
const _hoisted_6 = { class: "p-field p-col p-col-12 p-md-6 p-lg-3" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", null, "Chọn loại thống kê", -1)
const _hoisted_8 = { class: "p-field p-col p-col-12 p-md-6 p-lg-3" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", null, "Nhập giá trị: ", -1)
const _hoisted_10 = {
  class: "p-field p-col p-col-12 p-md-6 p-lg-2",
  style: {"margin-left":"5px"}
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", null, "Xuất biên bản:", -1)
const _hoisted_12 = {
  class: "p-field p-col p-col-12 p-md-6 p-lg-2",
  style: {"margin-left":"5px"}
}
const _hoisted_13 = /*#__PURE__*/_createElementVNode("label", null, "Tải biên bản", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "p-field p-col p-col-12 p-md-12 p-lg-12" }, null, -1)
const _hoisted_15 = { class: "p-field p-col-12 p-sm-12 p-md-12" }
const _hoisted_16 = { id: "loading" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("label", null, "Đang xử lý xuất báo cáo...", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_InputNumber = _resolveComponent("InputNumber")!
  const _component_Button = _resolveComponent("Button")!
  const _component_TabPanel = _resolveComponent("TabPanel")!
  const _component_TabView = _resolveComponent("TabView")!
  const _component_ProgressBar = _resolveComponent("ProgressBar")!
  const _component_Dialog = _resolveComponent("Dialog")!
  const _component_ConfirmDialog = _resolveComponent("ConfirmDialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_TabView, null, {
        default: _withCtx(() => [
          _createVNode(_component_TabPanel, null, {
            header: _withCtx(() => [
              _hoisted_3
            ]),
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_4, [
                _hoisted_5,
                _createElementVNode("div", _hoisted_6, [
                  _hoisted_7,
                  _createVNode(_component_Dropdown, {
                    id: "loaiThietBi",
                    modelValue: $setup.loai,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.loai) = $event)),
                    options: $setup.kind,
                    filter: "",
                    optionLabel: "label",
                    optionValue: "param",
                    placeholder: "Vui lòng chọn loại báo cáo ..."
                  }, null, 8, ["modelValue", "options"])
                ]),
                _createElementVNode("div", _hoisted_8, [
                  _hoisted_9,
                  _createVNode(_component_InputNumber, {
                    id: "giaTriTiepNhan",
                    modelValue: $setup.giaTri,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.giaTri) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_10, [
                  _hoisted_11,
                  _createVNode(_component_Button, {
                    label: "Xử lý",
                    icon: "pi pi-spinner",
                    iconPos: "left",
                    onClick: $setup.createBaoCaoTheoGiaTri,
                    disabled: !$setup.valid
                  }, null, 8, ["onClick", "disabled"])
                ]),
                _createElementVNode("div", _hoisted_12, [
                  _hoisted_13,
                  _createVNode(_component_Button, {
                    label: "Tải",
                    icon: "pi pi-download",
                    iconPos: "left",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.downLoadFileExport($setup.file))),
                    disabled: !$setup.file
                  }, null, 8, ["disabled"])
                ])
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _hoisted_14,
    _createElementVNode("div", _hoisted_15, [
      _createVNode(_component_Dialog, {
        header: "Đang xử lý",
        visible: $setup.loadingBar,
        "onUpdate:visible": _cache[3] || (_cache[3] = ($event: any) => (($setup.loadingBar) = $event))
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_16, [
            _hoisted_17,
            _createVNode(_component_ProgressBar, {
              mode: "indeterminate",
              style: {"height":".3em"}
            })
          ])
        ]),
        _: 1
      }, 8, ["visible"]),
      _createVNode(_component_ConfirmDialog)
    ])
  ]))
}